<template>
  <div class="footer">
    <div class="container">
      <div class="desc">
        <dl class="dl address">
          <dt>联系我们</dt>
          <dd>
            400-118-0970（09：00 a.m -- 19：00 p.m）<br>
            contact@ylzxvip.com<br>
            北京市-朝阳区-三里屯-新东路40号耀莱中心<br>
            北京新耀莱网络科技有限公司<br>
          </dd>
        </dl>
        <dl class="dl qr-code">
          <dt>关注耀莱在线</dt>
          <dd>
            <sr-qr-code :text="qrCodeSR" :size="qrCodeSize"/>
          </dd>
        </dl>
        <dl class="dl qr-code">
          <dt>商家入驻</dt>
          <dd>
            <sr-qr-code :text="qrCodeBusiness" :size="qrCodeSize"/>
          </dd>
        </dl>
      </div>
      <div class="copyright">

        © 2019-2020 北京新耀莱网络科技有限公司版权所有 ICP证：<a href="http://www.beian.miit.gov.cn" style="text-decoration:none;color: #fff;" >京ICP备19022411号</a>
      </div>
    </div>
  </div>
</template>

<script>
  import SrQrCode from '@/components/QRCode'
  export default {
    components: {
      SrQrCode
    },
    data () {
      return {
        qrCodeSize: 120,
        qrCodeSR: 'http://weixin.qq.com/r/eDjA2OLE_b_Graa7921q',
        qrCodeBusiness: 'http://weixin.qq.com/r/jjlIUNLEDo9xrZYz92yc'
      }
    }
  }
</script>

<style lang="less" scoped>
  .footer{
    background-color: #1a1a1a;
    color: #c6c6c6;
    font-size: 12px;
    .container {
      padding: 0 30px;
    }
    .desc {
      width: 900px;
      margin: 0 auto;
      overflow: hidden;
      padding: 60px 0;
    }
    .dl {
      float: left;
      & dt {
        padding-bottom: 30px;
        color: white;
      }
    }
    .address {
       width: 300px;
       & dd {
        line-height: 2;
       }
    }
    .qr-code {
      width: 300px;
      text-align: center;
    }
    .copyright {
      padding: 20px 0;
      border-top: 1px solid #666;
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue